(function () {
  'use strict';

  function addStyle() {
    if (document.getElementById('qoolish-speed-style')) return;
    const style = document.createElement('style');
    style.id = 'qoolish-speed-style';
    style.textContent = `
      img { content-visibility: auto; }
      img[loading="lazy"] { opacity: 0; transition: opacity .2s ease; }
      img[loading="lazy"].loaded { opacity: 1; }
      .qoolish-lazy-img { background-color: #f7f7f7; }
    `;
    document.head.appendChild(style);
  }

  function markLoaded(img) {
    img.classList.add('loaded');
  }

  function enhanceImages() {
    const images = Array.from(document.querySelectorAll('img'));
    const heroImage = images.find((img) => {
      const src = (img.getAttribute('src') || '').toLowerCase();
      const srcset = (img.getAttribute('srcset') || '').toLowerCase();
      const isLogo = img.classList.contains('header__heading-logo') || !!img.closest('header');
      return !isLogo && (src.includes('.webp') || src.includes('.jpg') || src.includes('.png') || srcset.includes('.webp') || srcset.includes('.jpg') || srcset.includes('.png'));
    });

    images.forEach((img) => {
      if (!img.getAttribute('decoding')) {
        img.setAttribute('decoding', 'async');
      }
      if (!img.getAttribute('width') || !img.getAttribute('height')) {
        const width = img.naturalWidth || 1200;
        const height = img.naturalHeight || 800;
        img.setAttribute('width', String(width));
        img.setAttribute('height', String(height));
      }

      if (img === heroImage) {
        if (!img.getAttribute('loading')) {
          img.setAttribute('loading', 'eager');
        }
        if (!img.getAttribute('fetchpriority')) {
          img.setAttribute('fetchpriority', 'high');
        }
      } else if (!img.getAttribute('loading')) {
        img.setAttribute('loading', 'lazy');
      }

      img.classList.add('qoolish-lazy-img');
      if (img.complete) {
        markLoaded(img);
        return;
      }
      img.addEventListener('load', () => markLoaded(img), { once: true });
    });
  }

  function init() {
    addStyle();
    enhanceImages();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
